// extracted by mini-css-extract-plugin
export default {"dialog":"edXBtoIFcPcyYaST"};